export default __webpack_public_path__ + "static/media/lagazzettadelmezzogiorno.1b507ad4.png";